"use client";

import _objectSpread from "/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/chidumebinkata/chadmeter/chadmeter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useContext } from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import FormContext from './FormContext';
import { jsx as _jsx } from "react/jsx-runtime";
var FormRange = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    id = _ref.id,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "id"]);
  var _useContext = useContext(FormContext),
    controlId = _useContext.controlId;
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-range');
  return /*#__PURE__*/_jsx("input", _objectSpread({}, props, {
    type: "range",
    ref: ref,
    className: classNames(className, bsPrefix),
    id: id || controlId
  }));
});
FormRange.displayName = 'FormRange';
export default FormRange;